var map = {
	"./bedroom.png": "./src/images/TKO/bedroom.png",
	"./bedroom2.png": "./src/images/TKO/bedroom2.png",
	"./bedroom3.png": "./src/images/TKO/bedroom3.png",
	"./kitchen.png": "./src/images/TKO/kitchen.png",
	"./livingroom.png": "./src/images/TKO/livingroom.png",
	"./wc.png": "./src/images/TKO/wc.png",
	"./wc2.png": "./src/images/TKO/wc2.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/TKO sync recursive \\.(png%7Cjpe?g%7Csvg)$";